/** 页面信息 */
const page = new (function () {
  this.title = '行政处罚案件'
  this.icon = 'iconfont iconicon_group'
  this.name = 'query_xzcf'
  /**菜单编号 */
  this.code = 'query_xzcf'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/query/xzcf'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
